import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./tailwind.css";
import "./uiVerbeter.css";
import App from "./App";

// Eén datumnotatie in de hele app: "ma 12 okt" (dag + maand altijd kort, zonder punt).
// Alleen voor nl-NL met dag én maand; "oktober 2026" en losse weekdagen blijven zoals ze zijn.
if (typeof Date !== "undefined" && !Date.prototype.__cpDatum) {
  const orig = Date.prototype.toLocaleDateString;
  Date.prototype.toLocaleDateString = function (loc, opt) {
    if (loc === "nl-NL" && opt && opt.day && opt.month && !opt.year) {
      const kort = { ...opt, month: "short" };
      if (opt.weekday) kort.weekday = "short";
      return orig.call(this, loc, kort).replace(/\./g, "");
    }
    return orig.call(this, loc, opt);
  };
  Date.prototype.__cpDatum = true;
}

// 💾 Browseropslag vol ("The quota has been exceeded")? Dan crashte de app.
// Nu: eerst grote, overbodige kopieën opruimen en opnieuw proberen; lukt het
// dan nog niet, dan wordt dat ene opslaan overgeslagen (de echte data staat
// in Firebase en IndexedDB) in plaats van dat de hele app vastloopt.
if (typeof Storage !== "undefined" && !Storage.prototype.__cpVeilig) {
  const origSet = Storage.prototype.setItem;
  const isVol = (e) =>
    e && (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.code === 22 || e.code === 1014 || /quota/i.test(e.message || ""));
  // Van minst naar meest belangrijk: wat er als eerste weg mag
  const OPRUIMEN = ["cp_emergency_backup", "cp_last_known_good", "cp_loginFotos", "cp_app_data"];
  Storage.prototype.setItem = function (sleutel, waarde) {
    try {
      return origSet.call(this, sleutel, waarde);
    } catch (e) {
      if (!isVol(e)) throw e;
      for (const k of OPRUIMEN) {
        if (k === sleutel) continue;
        try {
          this.removeItem(k);
          return origSet.call(this, sleutel, waarde);
        } catch (e2) {
          if (!isVol(e2)) throw e2;
        }
      }
      console.warn(`Opslag vol: "${sleutel}" niet lokaal bewaard`);
      return undefined;
    }
  };
  Storage.prototype.__cpVeilig = true;
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// Testversie (Vercel-preview van een andere branch dan main): duidelijk label,
// zodat niemand de test met de echte app verwart. Let op: dezelfde echte data.
const IS_TEST = process.env.REACT_APP_VERCEL_ENV === "preview";
const TEST_BRANCH = process.env.REACT_APP_VERCEL_GIT_COMMIT_REF || "test";
if (IS_TEST && typeof document !== "undefined") document.title = `TEST · ${document.title}`;

const TestLabel = () => (
  <div
    style={{
      position: "fixed", top: 0, left: "50%", transform: "translateX(-50%)", zIndex: 2147483000,
      pointerEvents: "none", background: "#FFCA55", color: "#7A5226", borderRadius: "0 0 10px 10px",
      padding: "1px 10px 2px", fontSize: 10, fontWeight: 600, boxShadow: "0 1px 4px rgba(0,0,0,.15)",
      whiteSpace: "nowrap",
    }}
  >
    TESTVERSIE · {TEST_BRANCH} · echte data
  </div>
);

root.render(
  <StrictMode>
    <App />
    {IS_TEST && <TestLabel />}
  </StrictMode>
);

// Service worker: snellere start en werkt als web-app op het beginscherm.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
